import { Meta, Title } from "@solidjs/meta";
import { useLocation } from "@solidjs/router";
import { Show } from "solid-js";
import { ClosingCTA } from "~/components/marketing/ClosingCTA";
import { SHOW_SOCIAL_PROOF } from "~/components/marketing/content";
import { marketingCard } from "~/components/marketing/sections";
import { TestimonialsSection, TrustSection } from "~/components/marketing/TrustSections";
import { useI18n } from "~/i18n";
import { getAppBaseUrl } from "~/lib/getAppBaseUrl";
import { BuildersSection } from "./internal/BuildersSection";
import { CapabilitySections } from "./internal/CapabilitySections";
import { CommunitySection, FaqSection } from "./internal/ClosingSections";
import { CompareSection } from "./internal/CompareSection";
import { HeroSection } from "./internal/HeroSection";
import { HowItWorks } from "./internal/HowItWorks";
import { IntegrationsSection } from "./internal/IntegrationsSection";
import { ProofStrip } from "./internal/ProofStrip";
import { SpeakersSection } from "./internal/SpeakersSection";

/** The chief.bot homepage. Section order and copy follow the website content brief. */
export const HomePage = () => {
  const { t } = useI18n();
  const location = useLocation();
  // A section or demo link takes its og:title and og:url from the marketing layout.
  const linked = () => marketingCard("/", location.query.s) !== undefined;
  return (
    <>
      <Title>{t("marketing.home.meta_title")}</Title>
      <Meta name="description" content={t("marketing.home.hero.sub")} />
      <Show when={!linked()}>
        <Meta property="og:title" content={t("marketing.home.meta_title")} />
        <Meta name="twitter:title" content={t("marketing.home.meta_title")} />
        <Meta property="og:url" content={`${getAppBaseUrl()}/`} />
      </Show>
      <Meta property="og:description" content={t("marketing.home.hero.sub")} />
      <Meta property="og:type" content="website" />
      <Meta name="twitter:description" content={t("marketing.home.hero.sub")} />
      <HeroSection />
      <Show when={SHOW_SOCIAL_PROOF}>
        <ProofStrip />
      </Show>
      <HowItWorks />
      <SpeakersSection />
      <CapabilitySections />
      <BuildersSection />
      <IntegrationsSection />
      <Show when={SHOW_SOCIAL_PROOF}>
        <TestimonialsSection />
      </Show>
      <TrustSection />
      <CompareSection />
      <CommunitySection />
      <FaqSection />
      <ClosingCTA id="home-closing" title={t("marketing.home.closing.title")} from="homepage closing" />
    </>
  );
};
